import { Flex, InputLabel, TextInput } from "@mantine/core";
import type { UseFormReturnType } from "@mantine/form";
import type { CollectCustomerInfoFormData } from "@/sales-tools/home-product/hooks/useCollectCustomerInfoForm";
import classes from "./CollectCustomerInfo.module.css";

type ManualAddressInputProps = {
    form: UseFormReturnType<CollectCustomerInfoFormData>;
};

export const ManualAddressInput = ({ form }: ManualAddressInputProps) => {
    return (
        <>
            <InputLabel size="xs">Home address</InputLabel>

            <Flex direction="column" gap="0.75rem" mt="3xs">
                <TextInput
                    label={"Street address"}
                    aria-label="Street address"
                    className="fs-mask"
                    id="customer-street-address-input"
                    size="sm"
                    placeholder="Street address"
                    classNames={{ input: classes.styledInput }}
                    {...form.getInputProps("address1")}
                    styles={{ label: { fontSize: "0.75rem" } }}
                />

                <Flex gap="0.75rem">
                    <TextInput
                        label={"City"}
                        aria-label="City"
                        className="fs-mask"
                        id="customer-city-input"
                        size="sm"
                        placeholder="City"
                        classNames={{ input: classes.styledInput }}
                        {...form.getInputProps("city")}
                        flex={3}
                        styles={{ label: { fontSize: "0.75rem" } }}
                    />

                    <TextInput
                        label={"State"}
                        aria-label="State"
                        className="fs-mask"
                        id="customer-state-input"
                        size="sm"
                        placeholder="State"
                        classNames={{ input: classes.styledInput }}
                        {...form.getInputProps("state")}
                        flex={1}
                        styles={{ label: { fontSize: "0.75rem" } }}
                    />

                    <TextInput
                        label={"Zip code"}
                        aria-label="Zip code"
                        className="fs-mask"
                        id="customer-zip-code-input"
                        size="sm"
                        placeholder="Zip code"
                        classNames={{ input: classes.styledInput }}
                        {...form.getInputProps("zip")}
                        flex={2}
                        styles={{ label: { fontSize: "0.75rem" } }}
                    />
                </Flex>
            </Flex>
        </>
    );
};
